import { useContext } from "react";
import { ThemeContext } from "../context/ThemeContext";

export function useThemeMode() {
  const mode = useContext(ThemeContext);
  return mode;
}
